import React from "react";
import { ShowPreview } from "../Show/ShowPreviewPanel";
import { FlightSegmentPreview } from "../Flight/FlightPreviewPanel";
import { TrainSegmentPreview } from "../Train/TrainPreviewPanel";
import { GroundTransportPreview } from "../GroundTransport/GroundTransportPreviewPanel";
import { ExternalEventPreview } from "../ExternalEvent/ExternalEventPreview";

interface AppointmentPreviewProps {
  appointment: server.dto.AppointmentForPlanner;
  children: JSX.Element;
  onChange: () => void
}

export const AppointmentPreview = (props: AppointmentPreviewProps) => {
  const { appointment, children } = props;

  switch (appointment.type.value) {
    case "externalCalendar":
      return <ExternalEventPreview externalEventId={appointment.id} trigger={children} />;
    case "show":
      return <ShowPreview canEdit onChange={props.onChange} showId={appointment.id} trigger={children} />;
    case "flight":
      return <FlightSegmentPreview flightSegmentId={appointment.id} trigger={children} />;
    case "train":
      return <TrainSegmentPreview trainSegmentId={appointment.id} trigger={children} />;
    case "groundTransport":
      return <GroundTransportPreview groundTransportId={appointment.id} trigger={children} />;
    default:
      return children;
  }
};

interface AppointmentPreviewPlannerProps {
  appointment: server.dto.PlannerAppointment;
  onChange: () => void;
  children: JSX.Element;
}

export const AppointmentPreviewPlanner = (props: AppointmentPreviewPlannerProps) => {
  const { appointment, children, onChange } = props;

  switch (appointment.type.value) {
    case "externalCalendar":
      return <ExternalEventPreview externalEventId={appointment.externalEventId} trigger={children} />;
    case "show":
      return <ShowPreview canEdit onChange={onChange} showId={appointment.showId} trigger={children} />;
    case "flight":
      return <FlightSegmentPreview flightSegmentId={appointment.flightSegmentId} trigger={children} />;
    case "train":
      return <TrainSegmentPreview trainSegmentId={appointment.trainSegmentId} trigger={children} />;
    case "groundTransport":
      return <GroundTransportPreview groundTransportId={appointment.groundTransportId} trigger={children} />;
    default:
      return children;
  }
};